const model = {
    permissionList: [],
    user: null,
    error: null,
    loading: false
};
    
export default model;